/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCarePatient
 */
export interface MatrixCarePatient {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    middle_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    gender?: MatrixCarePatientGenderEnum;
    /**
     * 
     */
    date_of_birth?: string;
    /**
     * 
     */
    phone_number?: string;
    /**
     * 
     */
    ssn?: string;
    /**
     * 
     */
    medical_record_number?: string;
    /**
     * 
     */
    race_id?: string;
    /**
     * 
     */
    religion?: MatrixCarePatientReligionEnum;
    /**
     * 
     */
    marital_status?: MatrixCarePatientMaritalStatusEnum;
    /**
     * 
     */
    language?: string;
    /**
     * 
     */
    address?: string;
    /**
     * 
     */
    state_id?: string;
    /**
     * 
     */
    primary_medicare_number?: string;
    /**
     * 
     */
    primary_medicaid_number?: string;
    /**
     * 
     */
    secondary_medicare_number?: string;
    /**
     * 
     */
    payer?: string;
}


/**
 * @export
 */
export const MatrixCarePatientGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other',
} as const;
export type MatrixCarePatientGenderEnum = typeof MatrixCarePatientGenderEnum[keyof typeof MatrixCarePatientGenderEnum];

/**
 * @export
 */
export const MatrixCarePatientReligionEnum = {
    _7thDayAdventist: '7th Day Adventist',
    Atheist: 'Atheist',
    Agnostic: 'Agnostic',
    Apolistic: 'Apolistic',
    Apostolic: 'Apostolic',
    AssemblyOfGod: 'Assembly of God',
    Baptist: 'Baptist',
    Buddhist: 'Buddhist',
    Catholic: 'Catholic',
    Congregational: 'Congregational',
    Christian: 'Christian',
    ChristianScientist: 'Christian Scientist',
    ChurchOfChrist: 'Church of Christ',
    ChristianMissionaryAlliance: 'Christian Missionary Alliance',
    ChurchOfTheNazarene: 'Church of the Nazarene',
    ChristianReformed: 'Christian Reformed',
    Covenant: 'Covenant',
    DisciplesOfChrist: 'Disciples of Christ',
    Episcopalian: 'Episcopalian',
    Evangelical: 'Evangelical',
    FirstAssembly: 'First Assembly',
    GreekOrthodox: 'Greek Orthodox',
    Hinduism: 'Hinduism',
    Islam: 'Islam',
    Judaism: 'Judaism',
    JehovahsWitness: 'Jehovah\'s Witness',
    Lutheran: 'Lutheran',
    ChurchOfTheLatterDaySaints: 'Church of the Latter Day Saints',
    Methodist: 'Methodist',
    Mennonite: 'Mennonite',
    Mormon: 'Mormon',
    Moravian: 'Moravian',
    None: 'None',
    NonDenominational: 'Non-Denominational',
    Orthodox: 'Orthodox',
    Protestant: 'Protestant',
    Pentecostal: 'Pentecostal',
    Presbyterian: 'Presbyterian',
    Quaker: 'Quaker',
    Scientology: 'Scientology',
    Taoist: 'Taoist',
    Traditional: 'Traditional',
    Unitarian: 'Unitarian',
    Unknown: 'Unknown',
} as const;
export type MatrixCarePatientReligionEnum = typeof MatrixCarePatientReligionEnum[keyof typeof MatrixCarePatientReligionEnum];

/**
 * @export
 */
export const MatrixCarePatientMaritalStatusEnum = {
    Single: 'single',
    DomesticPartner: 'domestic_partner',
    Married: 'married',
    Separated: 'separated',
    Divorced: 'divorced',
    Widowed: 'widowed',
    UnknownDeclined: 'unknown_declined',
} as const;
export type MatrixCarePatientMaritalStatusEnum = typeof MatrixCarePatientMaritalStatusEnum[keyof typeof MatrixCarePatientMaritalStatusEnum];


/**
 * Check if a given object implements the MatrixCarePatient interface.
 */
export function instanceOfMatrixCarePatient(value: object): value is MatrixCarePatient {
    return true;
}

export function MatrixCarePatientFromJSON(json: any): MatrixCarePatient {
    return MatrixCarePatientFromJSONTyped(json, false);
}

export function MatrixCarePatientFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatient {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'date_of_birth': json['date_of_birth'] == null ? undefined : json['date_of_birth'],
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'medical_record_number': json['medical_record_number'] == null ? undefined : json['medical_record_number'],
        'race_id': json['race_id'] == null ? undefined : json['race_id'],
        'religion': json['religion'] == null ? undefined : json['religion'],
        'marital_status': json['marital_status'] == null ? undefined : json['marital_status'],
        'language': json['language'] == null ? undefined : json['language'],
        'address': json['address'] == null ? undefined : json['address'],
        'state_id': json['state_id'] == null ? undefined : json['state_id'],
        'primary_medicare_number': json['primary_medicare_number'] == null ? undefined : json['primary_medicare_number'],
        'primary_medicaid_number': json['primary_medicaid_number'] == null ? undefined : json['primary_medicaid_number'],
        'secondary_medicare_number': json['secondary_medicare_number'] == null ? undefined : json['secondary_medicare_number'],
        'payer': json['payer'] == null ? undefined : json['payer'],
    };
}

export function MatrixCarePatientToJSON(json: any): MatrixCarePatient {
    return MatrixCarePatientToJSONTyped(json, false);
}

export function MatrixCarePatientToJSONTyped(value?: MatrixCarePatient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'gender': value['gender'],
        'date_of_birth': value['date_of_birth'],
        'phone_number': value['phone_number'],
        'ssn': value['ssn'],
        'medical_record_number': value['medical_record_number'],
        'race_id': value['race_id'],
        'religion': value['religion'],
        'marital_status': value['marital_status'],
        'language': value['language'],
        'address': value['address'],
        'state_id': value['state_id'],
        'primary_medicare_number': value['primary_medicare_number'],
        'primary_medicaid_number': value['primary_medicaid_number'],
        'secondary_medicare_number': value['secondary_medicare_number'],
        'payer': value['payer'],
    };
}

